import React from "react";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getClientid,
  getRoleList,
  getUserRole,
  getMenuList,
  getUserList,
  getUserInfo,
} from "redux/selectors";
import { Row, Col } from "antd";
import styled from "@emotion/styled";
import CheckInCheckout from "molecules/CheckInCheckout";
import UserMonthlyReport from "molecules/UserMonthlyReport";
import UserCheckinReport from "molecules/UserCheckinReport";
import NonStaffDashboard from "molecules/NonStaffDashboard";
import UserLeaveReport from "molecules/UserLeaveReport";
import BirthdaySpotLight from "./DashboardComponent/BirthdaySpotLight";
import AnnouncementList from "./DashboardComponent/AnnouncementList";
import UpcommingHolidayLists from "./DashboardComponent/UpcommingHolidayLists";
import MyTaskList from "./DashboardComponent/MyTaskList";
import { EyeFilled } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const StyledRow = styled(Row)`
  padding-top: 5px;
`;

const GutterCol = styled(Col)`
  margin-bottom: 25px;
`;

const MyDashboard = ({ userRoleId, userInfo }) => {
  const history = useHistory();
  return (
    <div>
      <div className="w-100 text-end px-2">
        <EyeFilled
          style={{ fontSize: 20 }}
          className=""
          onClick={() => history.push("/myshift")}
        />
      </div>
      <>
        <StyledRow gutter={[16, 0]}>
          {/* Row 1: CheckIn + Monthly | Announcement */}
          <GutterCol xs={24} sm={24} xl={12}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <CheckInCheckout />
              </Col>
              <Col span={24}>
                <UserMonthlyReport />
              </Col>
            </Row>
          </GutterCol>

          <GutterCol xs={24} sm={24} xl={12}>
            <UserCheckinReport />

            {/* <MyTaskList /> */}
          </GutterCol>

          {/* Row 2: CheckIn Report | MyTask */}
          {/* <GutterCol xs={24} sm={24} xl={12}>
            <UserCheckinReport />
          </GutterCol> */}

          <GutterCol xs={24} sm={24} xl={24}>
            <AnnouncementList />
          </GutterCol>

          {/* Row 3: Birthday | Upcoming Holidays */}
          <GutterCol xs={24} sm={24} md={12}>
            <BirthdaySpotLight />
          </GutterCol>

          <GutterCol xs={24} sm={24} md={12}>
            <UpcommingHolidayLists />
          </GutterCol>

          {/* Row 4: Leave Report */}
          <GutterCol xs={24}>
            <UserLeaveReport />
          </GutterCol>
        </StyledRow>
      </>

      {userRoleId == 1 && <NonStaffDashboard />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  ClientId: getClientid(state),
  roleList: getRoleList(state),
  userRoleType: getUserRole(state),
  menuList: getMenuList(state),
  userList: getUserList(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(MyDashboard);
